import {useContext} from 'react';

import {LayoutContext} from '../contexts/LayoutStore';

export const useLayoutStore = () => useContext(LayoutContext);
